import { useEffect, useState } from 'react';
import { actionModalEventManager } from './useModalEventManager';
import { useProviderContext } from './context';

const useModalAction = ({
  id,
  onHide,
  onBeforeShow,
  onContextUpdate,
}: {
  id?: string;
  onHide: (data?: any) => void;
  onBeforeShow?: (data?: any) => void;
  onContextUpdate: () => void;
}) => {
  const [visible, setVisible] = useState(false);
  const currentContext = useProviderContext();

  useEffect(() => {
    if (!id) return undefined;
    const subscriptions = [
      actionModalEventManager.subscribe(
        `show_${id}`,
        (data: any, context?: string) => {
          if (currentContext !== context) return;
          if (visible) return;
          onContextUpdate?.();
          onBeforeShow?.(data);
          setVisible(true);
        },
      ),
      actionModalEventManager.subscribe(`hide_${id}`, (data: any, context) => {
        if (currentContext !== context) return;
        onHide?.(data);
      }),
    ];
    return () => {
      subscriptions.forEach((s) => s?.unsubscribe?.());
    };
  }, [id, onHide, onBeforeShow, onContextUpdate, visible, currentContext]);

  return {
    visible,
    setVisible,
  };
};

export default useModalAction;
